<template>
  <div>
    <div
      class="innerBox"
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 7.5px 10px;
      "
    >
      <button
        class="btn"
        style="font-size: 16px; color: #6c6c6c; font-weight: bold; padding: 4px"
        @click="$router.go(-1)"
      >
        <i class="fas fa-angle-left mr-2"></i>Back
      </button>
      <p class="mb-0" style="font-size: 16px; color: #b9b9b9; font-weight: 600">
        | Plan Alokasi Muat <i class="fas fa-angle-right"></i>
      </p>
      <p
        class="mb-0 ml-1"
        style="font-size: 16px; color: #4b4b4b; font-weight: bold"
      >
        Edit Plan
      </p>
    </div>

    <form @submit.prevent="submitForm" class="innerBox col mt-4">
      <div v-for="(item, index) in items" :key="index">
        <div class="row mr-5 content-container">
          <div style="display: flex; align-items: center">
            <label class="mr-4">Tanggal</label>
            <flat-pickr
              :config="rangePickr"
              placeholder="Select Date"
              v-model="item.tgl"
            ></flat-pickr>
          </div>

          <div class="row ml-5 f-25">
            <label>Region</label>
            <!-- Render radio buttons for regions from the API response -->
            <div
              v-for="(regionOption, regionIndex) in regionOptions"
              :key="regionIndex"
            >
              <input
                type="radio"
                :id="'region-' + regionIndex"
                :value="regionOption"
                v-model="item.region"
                class="ml-2"
              />
              <label class="ml-1" :for="'region-' + regionIndex">{{
                regionOption
              }}</label>
            </div>
          </div>
        </div>

        <div class="mt-3 f-25 separator-line"></div>

        <div class="row mt-3 f-25">
          <label class="row-5 mr-5">Pilih Ekspedisi</label>
          <multiselect
            :options="ekspedisiOptions.map((x) => x.id)"
            :custom-label="
              (opt) => ekspedisiOptions.find((x) => x.id == opt).kode
            "
            placeholder="All Ekspedisi"
            v-model="item.ekspedisi"
            style="max-width: 20%"
          />
        </div>

        <!-- Dynamically render plant inputs based on API data -->
        <div
          class="row mt-3 f-25"
          style="display: flex; justify-content: space-between"
        >
          <!-- Divide the plant options into three columns -->
          <div
            class="col-4"
            v-for="(column, columnIndex) in 3"
            :key="columnIndex"
          >
            <!-- Render plant inputs for each column -->
            <div
              v-for="(plant, plantIndex) in plantOptions.slice(
                columnIndex * columnSize,
                (columnIndex + 1) * columnSize
              )"
              :key="plant.id"
              class="d-flex flex-column align-items-center"
            >
              <!-- Plant label and input in the same line -->
              <div class="d-flex align-items-center">
                <label class="mt-3 mr-2 f-25"
                  >Plant {{ plant.plant_code }}</label
                >
                <!-- Bind each input to a unique v-model -->
                <input
                  type="number"
                  :value="plantQuantities[plant.id]"
                  @input="updateQuantity(plant.id, $event.target.value)"
                  class="tms-input"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter row mt-3">
        <div class="col-lg-2 col-md-6"></div>
        <div class="col-lg-2 col-md-6"></div>
        <div class="col-lg-2 col-md-6"></div>
        <div class="col-lg-3 col-md-6"></div>
        <div class="col-lg-3 col-md-6">
          <button
            type="button"
            class="btn w-50"
            style="font-size: 100%; background-color: #82b0ef; color: #ffffff"
            @click="confirmSubmit()"
          >
            Simpan
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  name: "EditAlokasiPage",
  data() {
    let startDate = moment().startOf("month").format("YYYY-MM-DD");
    let currentDate = moment().format("YYYY-MM-DD");

    return {
      ekspedisiOptions: this.$store.getters.getEkspedisi.filter(val => val.kode !== 'All'),
      regionOptions: this.$store.getters.getRegion.filter(
        (val) => val !== "All"
      ), // Initialize regionOptions
      plantOptions: this.$store.getters.getPlant, // Store plant options from API
      columnSize: 0, // Number of plants per column
      plantQuantities: [], // Array to store quantities for each plant
      items: [
        {
          region: null,
          tgl: null,
          ekspedisi: null, // Initialize ekspedisi with null
          plant: [
            { item_plant: 1, qty: null },
            { item_plant: 2, qty: null },
            { item_plant: 3, qty: null },
            { item_plant: 4, qty: null },
            { item_plant: 5, qty: null },
            { item_plant: 6, qty: null },
          ],
        },
      ],
      rangePickr: {
        // mode: 'range',
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d M Y",
        altInputClass: "form-control input grey-flatpickr",
      },
      selected: {
        date: `${startDate} to ${currentDate}`,
      },
    };
  },
  components: {
    Multiselect,
  },
  created() {
    // Retrieve query parameters from the route
    const { id } = this.$route.params;

    this.$http.get(`/api/alokasi-muat/detail/${id}`).then((resp) => {
      // Set the retrieved data to the corresponding fields
      this.selected.date = resp.data.data.date;
      this.items[0].tgl = resp.data.data.date; // Assuming items is an array and the date is within items
      this.items[0].region = resp.data.data.region;
      this.items[0].ekspedisi = resp.data.data.ekspedisi_id;
      this.reArrangeDetails(resp.data.data.details);
    });
  },
  methods: {
    reArrangeDetails(details) {
      // Initialize plantQuantities object with null values for each plant
      const finalPlantOptions = this.plantOptions.reduce((acc, curr) => {
        acc[curr.id] = null;
        return acc;
      }, {});
      const finalDetails = details.reduce((acc, curr) => {
        acc[curr.plant_id] = curr.qty;
        return acc;
      }, {}); 
      this.plantQuantities = { ...finalPlantOptions, ...finalDetails };

      // Calculate the number of plants per column
      this.columnSize = Math.ceil(this.plantOptions.length / 3);
    },
    // Method to update plant quantity
    updateQuantity(plantId, quantity) {
      this.$set(this.plantQuantities, plantId, quantity);
      console.log(this.plantQuantities); // Add this line to log plantQuantities
    },
    confirmSubmit() {
      Swal.fire({
        title: "Konfirmasi Approval",
        text: "Apakah plant yang anda buat sudah sesuai?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Post Plant",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitForm();
        }
      });
    },
    submitForm() {
    const plantQuantitiesCopy = JSON.parse(JSON.stringify(this.plantQuantities));

    const filledPlants = Object.keys(plantQuantitiesCopy).reduce((acc, plantId) => {
        if (plantQuantitiesCopy[plantId] !== null) {
            acc.push({
                item_plant: Number(plantId),
                qty: Number(plantQuantitiesCopy[plantId])
            });
        }
        return acc;
    }, []);

    this.items[0].plant = filledPlants;

      // Prepare data to send
      const dataToSend = {
        items: this.items,
      };

      // Send the PUT request to the API with the ID included in the URL
      this.$http
        .put(`/api/alokasi-muat/update/${this.$route.params.id}`, dataToSend)
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Data saved successfully!",
          });
          this.$router.go(-1); // Go back to the previous route
          // Handle the API response here if needed
          console.log(response.data);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred while saving data!",
          });

          // Handle errors here
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.tms-input {
  outline-color: #e5e5e5;
  /* You can add other CSS properties here for styling */
  /* For example, padding, border, and more */
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.content-container {
  display: flex;
  align-items: center;
}

.separator-line {
  flex-grow: 1;
  height: 1px;
  background-color: #cbcbcb; /* Adjust the color as needed */
  margin: 0px; /* Adjust the margin as needed */
  margin-left: -40px; /* Adjust the margin as needed */
  margin-right: -20px; /* Adjust the margin as needed */
}

.centered {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  padding-left: 40px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #4d4d4d;
}

/* .center {
padding: 50px 20px;
display: flexbox;
flex-direction: column;
align-items: center;
justify-content: center;
} */

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
  display: flex;
  align-items: center;
}

.dropdown-container {
  flex: 1;
  margin-right: 10px;
}

.searchbar-container {
  flex: 2;
}

.dropdown {
  width: 100%;
}

.searchbar {
  width: 50%;
  padding: 5px;
}
</style>
